function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGreenCheckmark = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25,6.43v.57c0,1.35-.44,2.66-1.24,3.74-.81,1.08-1.94,1.87-3.23,2.25-1.29.38-2.67.34-3.94-.13-1.26-.47-2.34-1.33-3.08-2.46-.73-1.13-1.08-2.47-.99-3.81.09-1.34.61-2.62,1.49-3.65.88-1.02,2.06-1.74,3.37-2.04s2.69-.16,3.92.39M13.25,2l-6.25,6.26-1.88-1.88",
    style: {
      fill: "none",
      stroke: "#6ba543",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreenCheckmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/green_checkmark.e405bd43.svg";
export { ForwardRef as ReactComponent };